import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-workorder-tip',
  templateUrl: './workorder-tip.component.html',
  styleUrls: ['./workorder-tip.component.scss'],
})
export class WorkorderTipComponent {
  @Input() flag = false;
}
